<template>
    <el-dialog class="dialog-box" v-if="flowDialog" :visible.sync="flowDialog" width="80%">
        <img src="@Sys~/assets/flow.png" style="display:block; width:100%; height:auto; overflow:hidden; margin:0 auto;" />
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            // 流程图
            flowDialog: false
        }
    }
}
</script>